import { FC, useState } from "react";
import Form, { FormInstance, Rule } from "antd/lib/form";
import React from "react";
import { Input, Space } from "antd";
import { useTranslation } from "react-i18next";
import { InputType } from ".";
import { IconFont } from "../IconFont";
import classnames from "classnames";
import styles from "./styles.module.less";
import { PasswordLevel } from "../PasswordLevel";
import { getPasswordSecurityLevel } from "@/utils";

const layout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 24 },
};

export const ResetPasswordForm: FC<{ form: FormInstance<any>; regexA: Rule[]; regexB: Rule[] }> = ({
  form,
  regexA,
  regexB,
}) => {
  const { t } = useTranslation();
  const [passA, setPassA] = useState<InputType>(InputType.TEXT);
  const [passB, setPassB] = useState<InputType>(InputType.PASSWORD);

  const [password, setPassword] = useState("");

  return (
    <Form
      form={form}
      {...layout}
      onChange={() => {
        setPassword(form.getFieldsValue().password ?? "");
      }}
    >
      <Form.Item
        label={t("common.lodPasswordLabel")}
        name="oldPassword"
        rules={[
          {
            required: true,
            message: t("login.inputPwd"),
          },
        ]}
      >
        <Input
          type={passA}
          size="large"
          placeholder={t("common.loadPasswordPlaceholder")}
          suffix={
            <Space>
              <IconFont
                type={passA === InputType.TEXT ? "authing-eye-line" : "authing-eye-off-line"}
                className={classnames(styles["authing-password-icon"])}
                onClick={() => {
                  if (passA === InputType.TEXT) {
                    setPassA(InputType.PASSWORD);
                  } else {
                    setPassA(InputType.TEXT);
                  }
                }}
              />
            </Space>
          }
        />
      </Form.Item>

      <Form.Item label={t("common.initialNewPassword")} name="password" rules={regexA}>
        <Input
          type={passA}
          size="large"
          placeholder={t("login.inputPwd")}
          suffix={
            <Space>
              <IconFont
                type={passA === InputType.TEXT ? "authing-eye-line" : "authing-eye-off-line"}
                className={classnames(styles["authing-password-icon"])}
                onClick={() => {
                  if (passA === InputType.TEXT) {
                    setPassA(InputType.PASSWORD);
                  } else {
                    setPassA(InputType.TEXT);
                  }
                }}
              />
            </Space>
          }
        />
      </Form.Item>
      <Form.Item>
        <PasswordLevel level={getPasswordSecurityLevel(password)} />
      </Form.Item>
      <Form.Item label={t("user.confrimPwd")} name="confirmPassword" rules={regexB}>
        <Input
          type={passB}
          size="large"
          placeholder={t("common.placeConfirmPassword")}
          suffix={
            <Space>
              <IconFont
                type={passB === InputType.TEXT ? "authing-eye-line" : "authing-eye-off-line"}
                className={classnames(styles["authing-password-icon"])}
                onClick={() => {
                  if (passB === InputType.TEXT) {
                    setPassB(InputType.PASSWORD);
                  } else {
                    setPassB(InputType.TEXT);
                  }
                }}
              />
            </Space>
          }
        />
      </Form.Item>
    </Form>
  );
};

export const MobileResetPasswordForm: FC<{ form: FormInstance<any>; regexA: Rule[]; regexB: Rule[] }> = ({
  form,
  regexA,
  regexB,
}) => {
  const { t } = useTranslation();
  const [passA, setPassA] = useState<InputType>(InputType.TEXT);
  const [passB, setPassB] = useState<InputType>(InputType.PASSWORD);
  return (
    <Form form={form} {...layout}>
      <Form.Item
        label={t("common.lodPasswordLabel")}
        name="oldPassword"
        rules={[
          {
            required: true,
            message: t("login.inputPwd"),
          },
        ]}
      >
        <Input
          type={passA}
          size="large"
          placeholder={t("common.loadPasswordPlaceholder")}
          suffix={
            <Space>
              <IconFont
                type={passA === InputType.TEXT ? "authing-eye-line" : "authing-eye-off-line"}
                className={classnames(styles["authing-password-icon"])}
                onClick={() => {
                  if (passA === InputType.TEXT) {
                    setPassA(InputType.PASSWORD);
                  } else {
                    setPassA(InputType.TEXT);
                  }
                }}
              />
            </Space>
          }
        />
      </Form.Item>
      <Form.Item label={""} name="password" rules={regexA}>
        <Input
          type={passA}
          placeholder={t("login.inputPwd")}
          size="large"
          suffix={
            <Space>
              <IconFont
                type={passA === InputType.TEXT ? "authing-eye-line" : "authing-eye-off-line"}
                className={classnames(styles["authing-password-icon"])}
                onClick={() => {
                  if (passA === InputType.TEXT) {
                    setPassA(InputType.PASSWORD);
                  } else {
                    setPassA(InputType.TEXT);
                  }
                }}
              />
            </Space>
          }
        />
      </Form.Item>
      <Form.Item label={""} name="confirmPassword" rules={regexB}>
        <Input
          type={passB}
          placeholder={t("common.placeConfirmPassword")}
          size="large"
          suffix={
            <Space>
              <IconFont
                type={passB === InputType.TEXT ? "authing-eye-line" : "authing-eye-off-line"}
                className={classnames(styles["authing-password-icon"])}
                onClick={() => {
                  if (passB === InputType.TEXT) {
                    setPassB(InputType.PASSWORD);
                  } else {
                    setPassB(InputType.TEXT);
                  }
                }}
              />
            </Space>
          }
        />
      </Form.Item>
    </Form>
  );
};
